<template>
    <div id="thank-you-mobile">
        <div class="message-mobile-wrapper">
            <div class="message-mobile">
                <h1>Thank <br/>You</h1>
                <div class="line"/>
                <p>We'll be in touch <br/> shortly!</p>
            </div>
        </div>
        <router-link style="text-decoration: none;" to="/">
            <v-btn
            class="close-message-button-mobile"
            color="white"
            x-large
            width="90vw"
            rounded
            >Take me back home</v-btn>
        </router-link>
    </div>
</template>

<script>
export default {

}
</script>
<style lang="scss">
.close-message-button-mobile{
    text-transform: none;
    font-weight: 500;
}
</style>
<style lang="scss" scoped>
#thank-you-mobile{
  background-color: #E4AF79;
  width: 100vw;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  z-index: 1000001;
  .message-mobile-wrapper{
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
    display: grid;
    align-items: center;
  }
  .message-mobile{
    color: white;
    font-size: 2rem;
    font-family: Poppins;
    font-style: normal;
    text-align: left;

    h1{
      line-height: 0.95;
      padding-left: 6vw;
    }
    p{
      font-size: 1.2rem;
      font-weight: 500;
      padding-left: 6vw;
    }
    .line{
      width: 100vw;
      height: 2px;
      background-color: white;
      margin: 5vh 0;
    }
  }
  .close-message-button-mobile{
    z-index: 1000;
    position: absolute;
    bottom: 6vw;
    left: 5vw;
    padding: 0 0;
  }
}
</style>
